import React, { Component } from 'react'
import { HashRouter, Redirect } from 'react-router-dom'
import { DEMO } from '../../../config/constant'
import { connect } from 'react-redux'
import { currentWidget, setRegPage } from '../../../action/action'
import { setMakeUserLoginViaFindReservation } from '../../action/action'
import { setLoader } from '../../action/homeAction'


const fakePreCheckinWidget = {
 
  "btnImageUrl": "/../cmsData/hoteligenceClient/widgets/USMIAVH_812_1705_USDALVH_2899_3901_w_checkin.png",
  "widgetHeaderImageUrl": "/../cmsData/hoteligenceClient/widgets/USMIAVH_812_9785_USDALVH_2899_4541_w_checkin.png",
  "widgetTypeUniqueId": "BLANKFORM",
  "widgetTitle": "Find my reservation",
  "widgetDesc": "Oh hi there, ready to check-in? Right this way…",
  "widgetType": "Pre Check-in",
  "widgetTypeName": "Pre Check-in",
  "displayName": "Check In",
  // "path": "/checkin/id",
  "include": true,
  "alterNativeName": [
      "pre check-in",
      "pre checkin"
  ],
  "compName": "Pre Check-in",
  "compImage": ""
}

class Checkin extends Component {

  componentDidMount = async()=>{
    if(this.props.makeUserLoginViaFindReservation){
      await this.props.currentWidget(fakePreCheckinWidget);
      this.props.setLoader(false)
      this.props.setRegPage(false)
      this.props.setMakeUserLoginViaFindReservation(false);
    } 
  }
 
  render() {
    return (
        <HashRouter>
            <Redirect exact to={DEMO ? "/checkin/confidence/verified/demoBooking" : '/checkin/confidence/verified/booking/'} />
        </HashRouter>
    )
  }
}

const mapStateToProps=(state)=>{
  return {
    makeUserLoginViaFindReservation: state.store2.makeUserLoginViaFindReservation,

  }
}

export default connect(mapStateToProps,{setRegPage,currentWidget,setMakeUserLoginViaFindReservation,setLoader})(Checkin)